import React from 'react';

export type HubspotFormData = {
  formId: string;
  portalId: string;
};

let isScriptLoaded = false;

function useHubspotForm(
  formId: string,
  data: HubspotFormData,
  containerRef?: React.MutableRefObject<HTMLElement | undefined>
) {
  const [submitTries, setSubmitTries] = React.useState<number>(0);
  const [email, setEmail] = React.useState<string>('');
  const [submitting, setSubmitting] = React.useState<boolean>(false);

  const createForm = () => {
    // @ts-ignore
    window.hbspt.forms.create({
      target: `#${formId}`,
      ...data
    });
  };

  const submitForm = (email: string) => {
    try {
      const hubspotForm: any = document.querySelector(`#${formId} form`);
      const hubspotInput: any = hubspotForm!.querySelector('input');

      hubspotInput.value = email;
      hubspotForm.submit();

      setSubmitting(false);
      setSubmitTries(0);

      return true;
    } catch (e) {
      if (submitTries + 1 >= 10) {
        setSubmitting(false);
        setSubmitTries(0);
      } else {
        setSubmitTries(submitTries + 1);
      }

      return false;
    }
  }

  const submit = (email: string) => {
    if (submitting) return;

    const submitSuccess = submitForm(email);

    setEmail(email);
    setSubmitting(!submitSuccess);
  }

  React.useEffect(() => {
    if (submitting) {
      const timerId = setInterval(() => submitForm(email), 500);

      return () => clearInterval(timerId);
    }
  }, [submitting, email, submitForm]);

  React.useEffect(() => {
    if (isScriptLoaded) {
      createForm();
    } else {
      const script = document.createElement('script');
      script.src = '//js.hsforms.net/forms/v2.js';
      script.charset = 'utf-8';
      script.async = true;
      script.onload = () => {
        isScriptLoaded = true;

        createForm();
      };
      document.body.appendChild(script);
    }

    const formWrapper = document.createElement('div');

    formWrapper.id = formId;

    const wrapper = containerRef && containerRef.current ? containerRef.current : document.body;

    wrapper.appendChild(formWrapper);

    return () => {
      wrapper.removeChild(formWrapper);
    };
  }, []);

  return submit;
}

export default useHubspotForm;
